import React from "react";
import { connect } from "react-redux";
import { withRouter, Link, RouteComponentProps } from "react-router-dom";
import * as Middleware from "@middlewares/index";

interface PropsInterface extends RouteComponentProps {
  location: any;
  Store: any;
  Dispatch: any;
  text: string;
  index: number;
  component?: (c: {
    setText?: (text: string) => void;
    setStatus?: (status: string) => void;
    startTimer?: (time?: number) => void;
  }) => void;
}

interface StateInterface {
  showTime: number;
  index: number;
  text: string;
  status: string;
}

class Process extends React.Component<PropsInterface, StateInterface> {
  constructor(Props: PropsInterface) {
    super(Props);
    this.state = {
      showTime: 5 * 1000, // 15 sec
      index: this.props.index,
      text: Props.text,
      status: "",
    };

    if (typeof this.props.component === "function") {
      this.props.component({
        setText: this.setText.bind(this),
        setStatus: this.setStatus.bind(this),
        startTimer: this.startTimer.bind(this),
      });
    }

    this.destroyAlert = this.destroyAlert.bind(this);
  }

  public setText(text: string) {
    this.setState({ text });
  }

  public setStatus(status: string) {
    this.setState({ status });
  }
  public startTimer(time: number = this.state.showTime) {
    setTimeout(() => {
      this.destroyAlert();
    }, time);
  }

  public destroyAlert() {
    setTimeout(() => {
      Middleware.Ui.Alert.close(this.state.index);
    }, 100);
  }

  public render() {
    return (
      <>
        <div className={"alert " + this.state.status}>
          <div className="text">{this.state.text}</div>
          <div className="close" onClick={this.destroyAlert}>
            x
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Process)
);
